import type { HouseholdContact } from '@shared/types';
import { PhoneIcon, GlobeIcon } from './Icons';
import { appleMapsUrl } from '@shared/maps';
import { formatPhone } from '@/lib/formatting';

export function ContactCard({ contact, id }: { contact: HouseholdContact; id?: string }) {
  return (
    <div className="card" id={id}>
      <h2>{contact.name}</h2>
      <p style={{ color: 'var(--color-ink-muted)', fontSize: 14 }}>
        {contact.role}
        {contact.organization ? ` · ${contact.organization}` : ''}
      </p>
      {contact.address && <p style={{ fontSize: 14, marginTop: 8 }}>{contact.address}</p>}
      {contact.notes && <div className="note-block">{contact.notes}</div>}
      <div className="action-row" role="group" aria-label={`Contact ${contact.name}`}>
        {contact.phone && (
          <a className="action-btn" href={`tel:${contact.phone}`} aria-label={`Call ${contact.name}`}>
            <PhoneIcon />
            Call
          </a>
        )}
        {contact.phone && (
          <a className="action-btn" href={`sms:${contact.phone}`} aria-label={`Text ${contact.name}`}>
            Text
          </a>
        )}
        {contact.email && (
          <a className="action-btn" href={`mailto:${contact.email}`} aria-label={`Email ${contact.name}`}>
            Email
          </a>
        )}
        {contact.address && (
          <a className="action-btn" href={appleMapsUrl(contact.address)} target="_blank" rel="noreferrer">
            Directions
          </a>
        )}
        {contact.website && (
          <a className="action-btn" href={contact.website} target="_blank" rel="noreferrer">
            <GlobeIcon />
            Profile
          </a>
        )}
      </div>
      {(contact.phone || contact.phone_secondary) && (
        <p style={{ fontSize: 13, color: 'var(--color-ink-muted)', marginTop: 10 }}>
          {formatPhone(contact.phone)}
          {contact.phone_secondary ? ` · ${formatPhone(contact.phone_secondary)}` : ''}
        </p>
      )}
    </div>
  );
}
